import clsx from 'clsx';
import { Card, CardContent, Typography } from '@mui/material';
import { ReactNode } from 'react';
export const GRADIENT_HEADER_BACKGROUND = `linear-gradient(272deg, rgba(120, 100, 255, 0.60) -1.8%, rgba(152, 141, 252, 0.60) 14.33%, rgba(169, 218, 247, 0.60) 33.99%, rgba(255, 255, 255, 0.60) 58.68%, rgba(169, 218, 247, 0.60) 79.86%, rgba(122, 102, 255, 0.60) 100%), #EEEDFD`;
export const GradientHeaderCard = ({
  title,
  endContent,
  className,
  titleClassName,
  children
}) => {
  return <Card variant="outlined" sx={{
    mb: 3
  }} className={clsx('screening-print-gradient-card rounded-xl! pdf-avoid-break', className)}>
            <CardContent className="screening-print-gradient-card-content">
                <div className={clsx('screening-print-section-header flex justify-between items-center relative', 'bg-[#f3f0ff] -mx-4! -mt-4! mb-4! px-5! py-4! border-b border-gray-200!')} style={{
        background: GRADIENT_HEADER_BACKGROUND
      }}>
                    <div className="screening-print-section-header-overlay pointer-events-none absolute inset-0 z-0 print:hidden" style={{
          background: `rgba(255, 255, 255, 0.70)`,
          backdropFilter: `blur(18px)`
        }} aria-hidden />
                    <Typography variant="h6" sx={{
          fontWeight: 600
        }} className={clsx('relative z-10', titleClassName)}>
                        {title}
                    </Typography>
                    {endContent && <div className="relative z-10">{endContent}</div>}
                </div>
                <div className="screening-print-card-body relative">{children}</div>
            </CardContent>
        </Card>;
};